import * as actions from './mergers.action';
import reducer from './mergers.reducer';

export default {
  actions,
  reducer,
};
